import { render } from "./DistributionDashboard.vue?vue&type=template&id=5ee2777d&scoped=true"
import script from "./DistributionDashboard.vue?vue&type=script&lang=js"
export * from "./DistributionDashboard.vue?vue&type=script&lang=js"

import "@/styles/Distro-Dashboard.css?vue&type=style&index=0&id=5ee2777d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee2777d"]])

export default __exports__